/**
 * Cache leve de listas em localStorage para stale-while-revalidate.
 *
 * Sobrevive a reloads (o store zustand não persiste), então a tela mostra
 * os dados da última visita na hora e revalida em background. A latência
 * real das APIs (banco externo à AWS) deixa de ser percebida na maioria
 * dos acessos.
 *
 * Namespace por usuário evita vazar dados entre contas na mesma máquina;
 * `clearListCache` é chamado no logout como defesa adicional.
 */
const PREFIX = "listcache:";
const MAX_AGE_MS = 24 * 60 * 60 * 1000; // 24h: descarta cache muito velho

function buildKey(name, userId) {
  return `${PREFIX}${userId || "anon"}:${name}`;
}

export function readListCache(name, userId) {
  try {
    const raw = localStorage.getItem(buildKey(name, userId));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || !Array.isArray(parsed.data)) return null;
    if (Date.now() - (parsed.ts || 0) > MAX_AGE_MS) return null;
    return parsed.data;
  } catch {
    return null;
  }
}

export function writeListCache(name, userId, data) {
  try {
    if (!Array.isArray(data)) return;
    localStorage.setItem(
      buildKey(name, userId),
      JSON.stringify({ data, ts: Date.now() })
    );
  } catch {
    // localStorage cheio/indisponível: cache é best-effort, ignora
  }
}

export function clearListCache() {
  try {
    const toRemove = [];
    for (let i = 0; i < localStorage.length; i += 1) {
      const key = localStorage.key(i);
      if (key && key.startsWith(PREFIX)) toRemove.push(key);
    }
    toRemove.forEach((key) => localStorage.removeItem(key));

  } catch {
    // ignora
  }
}
